import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { ICheckable } from "@/Common/Models/UI/Inputs/ICheckable";

class LookupUIModel implements ICheckable {
    public Id: string;
    public Code: string;
    public Name: string;
    public Checked: boolean;
    public Target: CheckboxTarget;
    public Visible: boolean;

    constructor() {
        this.Id = GuidHelper.Empty();
        this.Code = "";
        this.Name = "";
    }
}

export { LookupUIModel };
